module.exports = __webpack_public_path__ + "img/chr_ts_90_15.2a88e291.png";